export default "__VITE_ASSET__7b0b5c1d__"